<template>
  <AdminForm
    :config="config"
    :form="form"
    :isBusy="isBusy"
    :options="options"
    @submit:create:success="submitCreateSuccess"
    @submit:update:success="submitUpdateSuccess"
  ></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "UserForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        role: null,
        renting_type_slug: "office",
        agencies: null,
        warehouse: null,
        status_slug: "user-active",
      },
      isBusy: false,
    };
  },
  computed: {
    isSuperAdmin: function () {
      return this.$store.getters["auth/roles"][0] === "ROLE_SUPER_ADMIN";
    },
    options: function () {
      const role_options = [...this.$store.getters[config.storeNamespace + "/getRoles"]];
      // Seul un super-admin connecté peut attribuer le rôle ROLE_SUPER_ADMIN
      // (absent de la liste de rôles sélectionnables par défaut).
      if (this.isSuperAdmin && !role_options.some((role) => role.value === "ROLE_SUPER_ADMIN")) {
        role_options.unshift({ value: "ROLE_SUPER_ADMIN", text: "Super administrateur" });
      }
      return {
        role_options,
        agencies_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        // INC-001 : entrepôt unique, option vide = accès à tous les entrepôts
        warehouse_options: [
          { value: null, text: "Aucun (tous les entrepôts)" },
          ...this.$store.getters["warehouse/getAll"].selectOptions("id", [
            "internal_code",
            " - ",
            "name",
          ]),
        ],
        employee_id_options: _.orderBy(
          this.$store.getters["employee/getAll"].selectOptions("id", [
            "firstname",
            " ",
            "lastname",
            " (",
            "number",
            " / ",
            "gaia_id",
            ")",
          ]),
          "text"
        ),
        status_slug_options: this.$store.getters["status/getByGroup"]("user").selectOptions(
          "status_slug",
          "name"
        ),
      };
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            role: item.roles ? item.roles[0] : null,
            employee_id: item.employee ? item.employee.id : null,
            agencies: item.agencies ? item.agencies.map((agency) => agency.id) : null,
            warehouse: item.warehouse ? item.warehouse.id : null,
            status_slug: item.status ? item.status.status_slug : null,
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("agency/getAllForSelect");
    this.$store.dispatch("warehouse/getAll"); // payload complet (internal_code) pour le libellé
    this.$store.dispatch("employee/getAllForSelect");
  },
  methods: {
    submitCreateSuccess(response) {
      this.$emit("submit:create:success", response);
    },
    submitUpdateSuccess(response) {
      this.$emit("submit:update:success", response);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/User/UserForm.vue